import React, { useContext, useCallback, useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { ReportsContext } from '../../../context';
import style from './style.module.less';

const FilterDropdown = ({ props = { disabled: false } }) => {
  const { apiKey, disabled, options } = props;
  const { setReportParams } = useContext(ReportsContext);
  const [selectedOption, setSelectedOption] = useState({});

  useEffect(() => {
    if (options.length > 0 && !selectedOption?.name) {
      setSelectedOption(options[0]);
      setReportParams({ apiKey, value: options[0][apiKey] });
    }
  }, [options, selectedOption, apiKey, setReportParams]);

  const onOptionChange = useCallback(
    (item) => {
      setSelectedOption(item);
      setReportParams({ apiKey, value: item[apiKey] });
    },
    [apiKey, setSelectedOption, setReportParams],
  );

  return (
    <DropdownMenu disabled={disabled} dropdownMenuShouldHaveWidthOfButton>
      <DropdownMenuToggler className={style['menu-toggler']} theme='white'>
        {selectedOption.name}
      </DropdownMenuToggler>
      {(!options || !options.length) && (
        <DropdownMenuItem selected>
          <span />
        </DropdownMenuItem>
      )}
      {options.map((item, index) => {
        const { name } = item;
        return (
          <DropdownMenuItem
            key={index}
            onClick={() => onOptionChange(item)} // leaving anon to support type into
            selected={selectedOption.name === name}
          >
            {name}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

FilterDropdown.propTypes = {
  props: PropTypes.shape({
    apiKey: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    options: PropTypes.array.isRequired,
  }),
};

export default FilterDropdown;
